import { render } from "./MobileNav.vue?vue&type=template&id=18495234"
import script from "./MobileNav.vue?vue&type=script&lang=js"
export * from "./MobileNav.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodeapps/vitamins/defensie/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__